import type { Action } from 'redux'

// Utils
import { safeLocalStorage as localStorage } from 'utils'

export default () => (next: (action: Action) => void) => (action: Action) => {
  const initialReferrer = localStorage.getItem('initialReferrer')
  const landingUrl = localStorage.getItem('landingUrl')

  if (!initialReferrer) {
    localStorage.setItem('initialReferrer', document.referrer)
  }

  if (!landingUrl) {
    localStorage.setItem('landingUrl', window && window.location && window.location.href)
  }

  return next(action)
}
